import React, { useEffect, useState } from 'react';
import { api } from '../../api.js';
import PhoneInput from '../../components/PhoneInput.jsx';
import { displayPhone } from '../../phone.js';

const TABS = [
  { key: 'drivers', label: 'Drivers' },
  { key: 'trucks', label: 'Trucks' },
  { key: 'trailers', label: 'Trailers' }
];

const STATUS_OPTIONS = ['available', 'on_load', 'off_duty', 'in_use', 'shop'];

export default function Fleet() {
  const [tab, setTab] = useState('drivers');
  const [items, setItems] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({});

  function load() {
    setItems(null);
    api(`/fleet/${tab}`).then(setItems).catch(() => setItems([]));
  }

  useEffect(() => { load(); setShowForm(false); setForm({}); }, [tab]);

  async function submitForm(e) {
    e.preventDefault();
    await api(`/fleet/${tab}`, { method: 'POST', body: form });
    setForm({});
    setShowForm(false);
    load();
  }

  async function updateStatus(id, status) {
    await api(`/fleet/${tab}/${id}`, { method: 'PATCH', body: { status } });
    load();
  }

  async function remove(id) {
    if (!confirm('Remove this record?')) return;
    await api(`/fleet/${tab}/${id}`, { method: 'DELETE' });
    load();
  }

  return (
    <div>
      <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16}}>
        <h1 style={{margin:0}}>Fleet &amp; drivers</h1>
        <button onClick={() => setShowForm(s => !s)}>{showForm ? 'Cancel' : '+ Add ' + tab.slice(0, -1)}</button>
      </div>

      <div style={{display:'flex', gap:6, marginBottom:16}}>
        {TABS.map(t => (
          <button key={t.key} onClick={() => setTab(t.key)}
                  style={{
                    background: tab === t.key ? 'var(--surface-2)' : 'transparent',
                    color: tab === t.key ? 'var(--amber)' : 'var(--text-dim)',
                    border: '1px solid var(--border)', borderRadius: 6, padding: '6px 14px'
                  }}>
            {t.label}
          </button>
        ))}
      </div>

      {showForm && (
        <form onSubmit={submitForm} style={{background:'var(--surface)', border:'1px solid var(--border)', borderRadius:8, padding:16, marginBottom:16, display:'flex', gap:10, flexWrap:'wrap', alignItems:'flex-end'}}>
          {tab === 'drivers' && (
            <>
              <label>Name<br/><input required value={form.name || ''} onChange={e => setForm(f => ({...f, name: e.target.value}))} /></label>
              <label>Phone<br/><PhoneInput value={form.phone || ''} onChange={v => setForm(f => ({...f, phone: v}))} /></label>
              <label>License #<br/><input value={form.licenseNo || ''} onChange={e => setForm(f => ({...f, licenseNo: e.target.value}))} /></label>
            </>
          )}
          {tab === 'trucks' && (
            <>
              <label>Unit number<br/><input required value={form.unitNumber || ''} onChange={e => setForm(f => ({...f, unitNumber: e.target.value}))} /></label>
              <label>Plate<br/><input value={form.plate || ''} onChange={e => setForm(f => ({...f, plate: e.target.value}))} /></label>
            </>
          )}
          {tab === 'trailers' && (
            <>
              <label>Unit number<br/><input required value={form.unitNumber || ''} onChange={e => setForm(f => ({...f, unitNumber: e.target.value}))} /></label>
              <label>Type<br/><input placeholder="Dry van, Reefer..." value={form.trailerType || ''} onChange={e => setForm(f => ({...f, trailerType: e.target.value}))} /></label>
            </>
          )}
          <button type="submit">Save</button>
        </form>
      )}

      {items === null && <div className="empty">Loading...</div>}
      {items && items.length === 0 && <div className="empty">No {tab} yet — add one above.</div>}
      {items && items.length > 0 && (
        <table>
          <thead>
            <tr>
              {tab === 'drivers' && <><th>Name</th><th>Phone</th><th>License</th></>}
              {tab === 'trucks' && <><th>Unit #</th><th>Plate</th></>}
              {tab === 'trailers' && <><th>Unit #</th><th>Type</th></>}
              <th>Status</th><th></th>
            </tr>
          </thead>
          <tbody>
            {items.map(item => (
              <tr key={item.id}>
                {tab === 'drivers' && <><td>{item.name}</td><td>{displayPhone(item.phone) || '—'}</td><td>{item.license_no || '—'}</td></>}
                {tab === 'trucks' && <><td>{item.unit_number}</td><td>{item.plate || '—'}</td></>}
                {tab === 'trailers' && <><td>{item.unit_number}</td><td>{item.trailer_type || '—'}</td></>}
                <td>
                  <select value={item.status} onChange={e => updateStatus(item.id, e.target.value)}>
                    {STATUS_OPTIONS.map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                </td>
                <td><button onClick={() => remove(item.id)} style={{background:'transparent', color:'var(--red)', border:'none', cursor:'pointer'}}>Remove</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
